module.exports = __webpack_public_path__ + "images/no-category-selected-bf5baa5a.svg";